import React, { Component } from 'react'
import { connect } from 'react-redux'
import auth from '../../common/auth'
import { Translate, getTranslate } from 'react-localize-redux'
import '../../assets/css/style.css'

class SetupManager extends Component {
	constructor(props) {
		super(props)
		this.state = {
			processFns: [],
			cleanFns: []
		}
	}

	componentDidMount() {
		if (this.props.isLoggedIn) {
			this.performQzTrayCheck()
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.isLoggedIn !== this.props.isLoggedIn) {
			this.performQzTrayCheck()
		}
	}

	performQzTrayCheck() {
		this.resetCheckStatus()
		this.performIndividualChecks().catch(err => {
			console.log(err)
		})
	}

	performIndividualChecks() {
		const fns = this.state.processFns
		let promiseChain = Promise.resolve()
		for (let i = 0; i < fns.length; i++) {
			promiseChain = promiseChain
				.then(() => {
					return fns[i]().catch(err => {
						throw err
					})
				})
				.catch(err => {
					throw err
				})
		}
		return promiseChain
	}

	resetCheckStatus() {
		this.state.cleanFns.forEach(fn => {
			fn()
		})
	}

	registerChild(processFn, cleanFn) {
		this.state.processFns.push(processFn)
		this.state.cleanFns.push(cleanFn)
	}

	render() {
		const children = React.Children.map(
			this.props.children,
			function(item) {
				return React.cloneElement(item, {
					registerCallback: this.registerChild.bind(this),
					runAllChecks: this.performQzTrayCheck.bind(this)
				})
			}.bind(this)
		)

		return (
			<div className="container-fluid">
				<div className="row">
					<div className="col-md-12">
						<div className="panel panel-default" id="qz-tray">
							<div className="panel-heading">
								<div className="pull-right">
									<a
										onClick={this.performQzTrayCheck.bind(this)}
										className="btn btn-primary"
									>
										<Translate id="stationSetup.RERUN_CHECKS" />
									</a>
								</div>
								<h4>
									<Translate id="stationSetup.HEADER" />
								</h4>
							</div>
							{children}
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default connect(state => ({
	isLoggedIn: auth.isLoggedIn(),
	translate: getTranslate(state.locale)
}))(SetupManager)



// WEBPACK FOOTER //
// ./src/components/qzSetup/SetupManager.js